import { CSSObject } from '@chakra-ui/react';

export const TextCheckbox: CSSObject = {
  color: 'gamma.200',
  fontWeight: 'medium',
};
